import React, { useEffect, useReducer, useState } from "react";
import { Collapse, Modal, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";

const API_BASE = "https://admin.vascularirdoctors.com/backend";

const initialState = {
  openCollapse1: false,
  openCollapse2: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "openCollapse1":
      return { ...state, openCollapse1: !state.openCollapse1 };
    case "openCollapse2":
      return { ...state, openCollapse2: !state.openCollapse2 };
    default:
      return state;
  }
};

const ExecutiveMembers = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [members, setMembers] = useState([]);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const [alert, setAlert] = useState({
    show: false,
    type: "",
    text: "",
  });

  const [form, setForm] = useState({
    name: "",
    role: "",
  });

  // EDIT STATE
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editImage, setEditImage] = useState(null);
  const [editData, setEditData] = useState({
    name: "",
    role: "",
    image: "",
  });

  // DELETE MODAL
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const showAlert = (type, text) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false, type: "", text: "" });
    }, 3000);
  };

  const fetchMembers = async () => {
    try {
      const res = await fetch(`${API_BASE}/executive-members`);
      const data = await res.json();
      setMembers(data);
    } catch (err) {
      console.log("FETCH MEMBERS ERROR:", err);
      showAlert("danger", "Unable to fetch executive members.");
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  // ADD MEMBER
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("name", form.name);
      data.append("role", form.role);
      if (image) data.append("image", image);

      const res = await fetch(`${API_BASE}/executive-members`, {
        method: "POST",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Executive member added successfully.");
        setForm({
          name: "",
          role: "",
        });
        setImage(null);
        fetchMembers();
      } else {
        showAlert("danger", result.message || "Failed to add member.");
      }
    } catch (err) {
      console.log("ADD MEMBER ERROR:", err);
      showAlert("danger", "Unable to connect to server.");
    }

    setLoading(false);
  };

  // OPEN EDIT
  const openEditModal = (member) => {
    setEditId(member.id);
    setEditData({
      name: member.name || "",
      role: member.role || "",
      image: member.image || "",
    });
    setEditImage(null);
    setShowModal(true);
  };

  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditImage = (e) => {
    setEditImage(e.target.files[0]);
  };

  // UPDATE MEMBER
  const updateMember = async () => {
    try {
      const data = new FormData();
      data.append("name", editData.name);
      data.append("role", editData.role);
      if (editImage) data.append("image", editImage);

      const res = await fetch(`${API_BASE}/executive-members/${editId}`, {
        method: "PUT",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Executive member updated successfully.");
        setShowModal(false);
        fetchMembers();
      } else {
        showAlert("danger", result.message || "Update failed.");
      }
    } catch (err) {
      console.log("UPDATE MEMBER ERROR:", err);
      showAlert("danger", "Unable to update executive member.");
    }
  };

  // DELETE
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const deleteMember = async () => {
    try {
      const res = await fetch(`${API_BASE}/executive-members/${deleteId}`, {
        method: "DELETE",
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Executive member deleted successfully.");
        fetchMembers();
      } else {
        showAlert("danger", result.message || "Delete failed.");
      }
    } catch (err) {
      console.log("DELETE MEMBER ERROR:", err);
      showAlert("danger", "Unable to delete executive member.");
    }

    setShowDeleteModal(false);
    setDeleteId(null);
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row page-titles align-items-center">
            <div className="col-sm-6">
              <ol className="breadcrumb">
                
                <li className="breadcrumb-item active">
                  Executive Members
                </li>
              </ol>
            </div>

            <div className="col-sm-6 text-sm-end mt-2 mt-sm-0">
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => dispatch({ type: "openCollapse1" })}
              >
                <i className="fas fa-times me-1"></i> Close
              </button>
            </div>
          </div>

          {alert.show && (
            <Alert variant={alert.type} className="mb-3 shadow-sm rounded-3">
              {alert.text}
            </Alert>
          )}

          <div className="row">
            {/* LEFT FORM */}
            <div className="col-xl-4">
              <div className="filter cm-content-box box-primary">
                <div className="content-title d-flex justify-content-between align-items-center">
                  <div className="cpa">Add Executive Member</div>
                  <div className="tools">
                    <button
                      type="button"
                      className="btn btn-sm btn-light border"
                      onClick={() => dispatch({ type: "openCollapse1" })}
                    >
                      <i
                        className={`fas ${
                          state.openCollapse1 ? "fa-angle-down" : "fa-angle-up"
                        }`}
                      ></i>
                    </button>
                  </div>
                </div>

                <Collapse in={!state.openCollapse1}>
                  <div className="cm-content-body form excerpt">
                    <div className="card-body">
                      <form onSubmit={submitHandler}>
                        <div className="mb-3">
                          <label className="form-label">Doctor Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            placeholder="Enter doctor name"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Role / Designation</label>
                          <textarea
                            className="form-control"
                            rows="4"
                            name="role"
                            value={form.role}
                            onChange={handleChange}
                            placeholder="Enter role/designation"
                            required
                          ></textarea>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Upload Image</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={handleImage}
                            accept="image/*"
                          />
                        </div>

                        {image && (
                          <div className="mb-3">
                            <img
                              src={URL.createObjectURL(image)}
                              alt="Preview"
                              style={{
                                width: "100%",
                                maxHeight: "220px",
                                objectFit: "cover",
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </div>
                        )}

                        <div>
                          <button
                            type="submit"
                            className="btn btn-primary w-100"
                            disabled={loading}
                          >
                            {loading ? "Saving..." : "Save Member"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>

            {/* RIGHT TABLE */}
            <div className="col-xl-8">
              <div className="filter cm-content-box box-primary">
                <div className="content-title d-flex justify-content-between align-items-center">
                  <div className="cpa">Executive Members List</div>
                  <div className="tools">
                    <button
                      type="button"
                      className="btn btn-sm btn-light border"
                      onClick={() => dispatch({ type: "openCollapse2" })}
                    >
                      <i
                        className={`fas ${
                          state.openCollapse2 ? "fa-angle-down" : "fa-angle-up"
                        }`}
                      ></i>
                    </button>
                  </div>
                </div>

                <Collapse in={!state.openCollapse2}>
                  <div className="cm-content-body publish-content form excerpt">
                    <div className="card-body py-3">
                      <div className="table-responsive">
                        <table className="table table-striped verticle-middle table-responsive-sm align-middle">
                          <thead>
                            <tr>
                              <th className="text-black">S.No</th>
                              <th className="text-black">Image</th>
                              <th className="text-black">Name</th>
                              <th className="text-black">Role</th>
                              <th className="text-black text-end">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {members.length > 0 ? (
                              members.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <img
                                      src={
                                        item.image
                                          ? `${API_BASE}${item.image}`
                                          : "https://via.placeholder.com/60x60?text=No+Image"
                                      }
                                      alt={item.name}
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </td>
                                  <td>{item.name}</td>
                                  <td style={{ maxWidth: "280px" }}>{item.role}</td>
                                  <td className="text-end">
                                    <div>
                                      <Link
                                        to={"#"}
                                        onClick={() => openEditModal(item)}
                                      >
                                        Edit
                                      </Link>
                                      <span> | </span>
                                      <Link
                                        to={"#"}
                                        onClick={() => confirmDelete(item.id)}
                                      >
                                        Delete
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  No executive members found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Executive Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={editData.name}
              onChange={handleEditChange}
            />
          </div>

          <div className="mb-3">
            <label>Role</label>
            <textarea
              className="form-control"
              rows="4"
              name="role"
              value={editData.role}
              onChange={handleEditChange}
            ></textarea>
          </div>

          <div className="mb-3">
            <label>Change Image</label>
            <input
              type="file"
              className="form-control"
              onChange={handleEditImage}
              accept="image/*"
            />
          </div>

          <div>
            <img
              src={
                editImage
                  ? URL.createObjectURL(editImage)
                  : editData.image
                  ? `${API_BASE}${editData.image}`
                  : "https://via.placeholder.com/600x250?text=No+Image"
              }
              alt="Preview"
              style={{
                width: "100%",
                maxHeight: "250px",
                objectFit: "cover",
                borderRadius: "10px",
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updateMember}>
            Update Member
          </Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE CONFIRM MODAL */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Executive Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this executive member? This action
          cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={deleteMember}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ExecutiveMembers;